/* @flow @format */

import { type ContextRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as React from 'react';
import qs from 'qs';

import type { Dispatch, StoreState } from '../redux/types';
import { fetchAgreementBegin } from '../redux/reducer/term';
import { signinBegin } from '../redux/reducer/auth';
import { toJapanTime } from '../utils';
import SplashPage from './SplashPage';
import ZkaiPage from './ZkaiPage';

const timelines = [
  {
    title: 'ピザを とどけよう',
    text: 'お客さんの家までロボットにピザの配達をしてもらいます。物事を捉えやすい形にして考える抽象化と簡単なプログラムを学びます。',
  },
  {
    title: 'おなじ うごきを くりかえそう',
    text: '遠くのお客さんの家までロボットにピザの配達をしてもらいます。プログラムの規則性を見つけながら、繰り返しの概念を学びます。',
  },
  {
    title: 'はいたつする みちを えらぼう',
    text: '道路状況を読み取り、最適なルートを探します。抽象的な情報を活用しながら、課題を解決する力を身につけます。',
  },
  {
    title: '目じるしを つかって とどけよう',
    text: '目印を手がかりにピザを配達します。状況の変化に対応できるプログラムを作ることで、条件処理の概念を学びます。',
  },
];

type State = {
  loading: boolean,
};

type OwnProps = {|
  ...ContextRouter,
|};

type Props = {
  ...OwnProps,
  signinBegin: typeof signinBegin,
  fetchAgreementBegin: typeof fetchAgreementBegin,

  fetching: boolean,
  active: number | void,
  accepted: boolean,
};

class ZPro2 extends React.Component<Props, State> {
  state = {
    loading: true,
  };

  restoreTitle: ?Function;
  token: string;

  constructor(props: Props) {
    super(props);

    const urlParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    if (!urlParams.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
    }
  }

  componentDidMount() {
    const oldTitle = document.title;
    this.restoreTitle = () => {
      document.title = oldTitle;
    };
    document.title = 'Z-pro 小学2年生';
    const urlParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this.token = typeof urlParams.token === 'string' ? urlParams.token : '';
    if (!this.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
      return;
    }

    const { fetchAgreementBegin } = this.props;

    fetchAgreementBegin({
      token: this.token,
      ticketSlug: 'z-pro-2',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });

    this.setState({ loading: false });
  }

  componentWillUnmount() {
    if (this.restoreTitle) this.restoreTitle();
  }

  handleStartClick = () => {
    this.props.signinBegin({
      token: this.token,
      ticketSlug: 'z-pro-2',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });
  };

  render() {
    const { loading } = this.state;
    const { fetching, accepted, active } = this.props;

    if (loading || fetching) return <SplashPage />;
    return (
      <ZkaiPage
        kind="pizza"
        timelines={timelines}
        tagline="Z会小学生コース/小学生タブレットコース 2年生"
        accepted={accepted}
        active={active}
        onStartClick={this.handleStartClick}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch, _: OwnProps) => ({
  signinBegin: (input) => dispatch(signinBegin(input)),
  fetchAgreementBegin: (input) => dispatch(fetchAgreementBegin(input)),
});

function mapStateToProps(state: StoreState) {
  const {
    term: { privacyPolicySigned, termsOfUseSigned, timestamp },
  } = state;

  const fetching = !timestamp;
  const accepted = privacyPolicySigned && termsOfUseSigned;
  let active = undefined;
  if (!fetching) {
    const japanTime = toJapanTime(new Date(timestamp));
    // Date.getMonth() return value in [0, 11]
    const month = japanTime.getUTCMonth() + 1;
    const dayOfMonth = japanTime.getUTCDate();
    if (1 <= month && month <= 3) {
      // the switching date of course 4 is Jan 5th
      if (month === 1 && dayOfMonth < 5) active = 2;
      else active = 3;
    } else if (4 <= month && month <= 6) {
      active = 0;
    } else if (7 <= month && month <= 9) {
      active = 1;
    } else if (10 <= month && month <= 12) {
      active = 2;
    }
  }

  return { fetching, accepted, active };
}

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ZPro2);
